<template>
  <section>
    <Quote
      v-if="section.type === 'quote'"
      class="content__row content__row--quote"
      :content="section.content" />
    <FullWithText
      v-if="section.type === 'full_width_text'"
      class="content__row content__row--quote"
      :content="section.content" />
    <ImageBlock
      v-if="section.type === 'image' && section.content.url"
      class="content__row content__row--image"
      :content="section.content" />
    <HeaderList
      v-if="section.type === 'header_and_list'"
      class="content__row content__row--header-list"
      :content="section.content"
      :list-header="section.content.list_header" />
    <HeaderTable
      v-if="section.type === 'header_and_table'"
      class="content__row content__row--header-table"
      :header="section.content.header"
      :content="section.content.table"
      :extra-column="section.content.extra_column"
      :table-header="section.content.table_header"
      :table-footer="section.content.table_footer" />
    <HeaderText
      v-if="section.type === 'header_and_text'"
      class="content__row content__row--header-text"
      :content="section.content" />
    <GoogleMap
      v-if="section.type === 'map'"
      :locations="section.content" />
  </section>
</template>

<script>
import Quote from '@/components/sections/types/Quote'
import ImageBlock from '@/components/sections/types/ImageBlock'
import HeaderList from '@/components/sections/types/HeaderList'
import HeaderTable from '@/components/sections/types/HeaderTable'
import HeaderText from '@/components/sections/types/HeaderText'
import GoogleMap from '@/components/sections/types/Map'
import FullWithText from "@/components/sections/types/FullWidthText.vue";

export default {
  name: 'Section',
  components: {
    FullWithText,
    Quote,
    ImageBlock,
    HeaderList,
    HeaderTable,
    HeaderText,
    GoogleMap
  },
  props: {
    section: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.content__row {
  @include section;
}
</style>
